<template>
	<div class="process-rate">
		<c-scroll v-if="list && show">
			<div class="flex">
				<template v-for="(item, i) in list">
					<div v-if="i" class="line" :key="`line${i}`"></div>
					<div :ref="`item${i}`" :key="`item${i}`" class="item flex-column flex-center" @mouseenter="detailHandle(i)" @mouseleave="detailHandle()">
						<c-progress class="circle" :rate="[item.fine_count, item.plan_count]" :color="item.state == 1 ? '#bbb' : item.state == 2 ? '#0D6EFE' : 'main'" type="circle" size="44" line-size="3" font-size="12" :style="{'background': item.state == 1 ? '#F5F5F5' : '#fff'}">
							<template #text="{rate}">
								<span v-if="item.state == 1" style="font-size: 10px; color: #666;">未开始</span>
								<span v-else-if="rate == 100" style="font-size: 20px;" :style="{'color': item.state == 2 ? '#0D6EFE' : 'var(--color-main)'}"><i class="c-icon-check"></i></span>
								<span v-else :style="{'color': rate > 100 ? '#f00' : ''}">{{rate.toFixed(0)}}%</span>
							</template>
						</c-progress>
						<p class="flex-center" :style="{'color': item.state == 1 ? '#999' : '#000'}"><span class="ellipsis">{{item.process_name}}</span></p>
						<div v-if="item.process_type == 2" class="tag" :style="{'background': item.out_sourcing_plan_count > 0 ? '#07b966' : '#0D6EFE'}">委外</div>
						<div v-if="item.priority == 1" class="state flex-center" style="background: #f00;"><i class="tf-urgent"></i></div>
						<div v-else-if="item.priority == 2" class="state flex-center" style="background: #999;"><i class="tf-pause"></i></div>
					</div>
				</template>
			</div>
		</c-scroll>

		<div v-if="detailData" ref="detail" class="process-rate-detail" :style="detailPosition" @mouseenter="detailHandle(-1)" @mouseleave="detailHandle()">
			<div class="head flex-between-center">
				<p>{{detailData.process_name}}</p>
				<c-state dict="orderStateDic" tag :value="detailData.state"></c-state>
			</div>
			<ul>
				<li class="flex-center-cross">
					<span>生产进度(%)：</span>
					<c-progress classs="flex-grow" :rate="[detailData.fine_count, detailData.plan_count]"></c-progress>
					<span>({{detailData.fine_count}}/{{detailData.plan_count}})</span>
				</li>
				<li class="flex-center-cross">
					<span>工序计划数：</span>
					<b>{{detailData.plan_count}}</b>
				</li>
				<li class="flex-center-cross">
					<span>加工类型：</span>
					<c-state dict="processTypeDic" :value="detailData.process_type"></c-state>
				</li>
				<li class="flex-center-cross" v-if="detailData.process_type == 2">
					<span>已委外数：</span>
					<b>{{detailData.out_sourcing_plan_count}}</b>
				</li>
				<li class="flex-center-cross">
					<span>检验方式：</span>
					<c-state dict="testModeDic" :value="detailData.test_mode"></c-state>
				</li>
				<li class="flex-center-cross" v-if="detailData.test_mode == 2">
					<span>首检状态：</span>
					<c-state dict="firestTestState" :value="detailData.firest_test_state"></c-state>
				</li>
				<li class="flex-center-cross">
					<span>良品数/不良品数：</span>
					<b style="color: var(--color-green)">{{detailData.fine_count}}</b>
					<span style="padding:0px 5px"> / </span>
					<b style="color: var(--color-red);">{{detailData.defects_count}}</b>
				</li>
				<li class="flex-center-cross">
					<span>良品数已审核/待审核：</span>
					<b>{{detailData.fine_count_2}}</b>
					<span style="padding:0px 5px"> / </span>
					<b>{{detailData.fine_count_1}}</b>
				</li>
				<li class="flex-center-cross" v-if="detailData.test_mode == 3">
					<span>已质检合格数：</span>
					<b>{{detailData.test_fine_count}}</b>
				</li>
				<li class="flex-center-cross">
					<span>计划时间：</span>
					<b>{{detailData.plan_start_date}} - {{detailData.plan_end_date}}</b>
				</li>
				<li class="flex-center-cross">
					<span>任务备注：</span>
					<b>{{detailData.remark}}</b>
				</li>
				<li class="flex-center-cross" v-if="detailData.output_start == 1">
					<span>最后打卡签到时间：</span>
					<b>{{detailData.last_sign_date || '-'}}</b>
				</li>
				<li class="flex-center-cross">
					<span>最后报工时间：</span>
					<b>{{detailData.last_output_date || '-'}}</b>
				</li>
			</ul>
			<div v-if="auth('m_work')" class="button flex">
				<a v-if="_events.output && auth('b_task_output') && detailData.output_is_auth == 1 && detailData.work_state == 2 && detailData.process_type == 1" class="flex-center flex-grow" @click="outputHandle">
					<i class="tf-output"></i>
					<span>新建报工</span>
				</a>
				<a v-if="_events.output && auth('b_task_sourcing') && (detailData.state==1 || detailData.state==2) && detailData.work_state == 2 && detailData.process_type == 2" class="flex-center flex-grow" @click="outSourcingHandle">
					<i class="tf-outsource"></i>
					<span>{{detailData.out_sourcing_plan_count>0?'再次外发':'外发'}}</span>
				</a>
				<a class="flex-center flex-grow" @click="globalDialog('taskDetail', {props: {id: detailData.id}})">
					<i class="tf-detail"></i>
					<span>查看报工</span>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {debounce, createStore, mapStore} from '@deanwu/vue-component-library'

	const STORE = createStore(Vue.extend({
		data() {
			return {
				queue: [],
				data: {}
			}
		},

		watch: {
			queue(val) {
				if (val.length) {
					this.getData();
				}
			}
		},

		methods: {
			get(id) {
				if (!this.queue.includes(id)) {
					this.$set(this.data, id, null);
					this.queue.push(id);
				}
			},

			getData: debounce(function() {
				this.request({
					url: '/work/statisticList',
					data: {
						work_list: this.queue.map(id => {
							return {id};
						})
					},
					success: data => {
						for (let id in data) {
							this.$set(this.data, id, data[id]);
						}
					}
				});
				this.queue = [];
			}, 100)
		}
	}));

	export default {
		name: 'processRate',
		
		props: {
			id: [Number, String],
			detail: {
				type: Boolean,
				default: true
			}
		},

		data() {
			return {
				store: STORE,
				show: false,
				detailData: null,
				detailPosition: null
			}
		},

		computed: {
			...mapStore(['data']),

			list() {
				return this.data[this.id] || null;
			}
		},

		mounted() {
			this.store.get(this.id);
			this.$nextTick(() => {
				let rect = this.$el.getBoundingClientRect();
				if (rect.bottom > 0 && rect.top < window.innerHeight) {
					this.show = true;
				} else {
					this._observer = new IntersectionObserver(entries => {
						if (entries[0].isIntersecting) {
							this.show = true;
							this._observer.disconnect();
						}
					});
					this._observer.observe(this.$el);
				}
			});
		},
		
		beforeDestroy() {
			this._observer && this._observer.disconnect();
		},
		
		methods: {
			detailHandle(i) {
				if (!this.detail) return;
				if (i === undefined) {
					this._detailRequest && this._detailRequest.abort();
					this._timer = setTimeout(() => {
						this.detailData = null;
						this.detailPosition = null;
					}, 50);
				} else {
					clearTimeout(this._timer);
					if (i != -1) {
						this.detailData = null;
						this._detailRequest = this.request({
							url: '/task/detail',
							data: {
								id: this.list[i].id
							},
							success: data => {
								let rect = this.$refs[`item${i}`][0].getBoundingClientRect();
								this.detailData = data;
								this.$nextTick(() => {
									let target = this.$refs.detail.getBoundingClientRect();
									this.detailPosition = {
										left: rect.left + 'px',
										top: window.innerHeight - rect.top - rect.height > target.height
											? rect.top + rect.height + 'px'
											: rect.top - target.height - 5 + 'px'
									}
								});
							}
						})
					}
				}
			},

			/******报工******/
			outputHandle() {
				this.globalDialog('outputEdit', {
					props: {
						byTask: true
					},
					data: this.detailData
				}, () => {
					this.$emit('output');
				});
				this.detailHandle();
			},

			/******外发******/
			outSourcingHandle() {
				this.globalDialog('outSourcingEdit', {
					props: {
						byTask: true
					},
					data: this.detailData
				}, () => {
					this.$emit('sourcing');
				});
				this.detailHandle();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.process-rate {
		position: relative;
		height: 70px;
		line-height: 16px;

		.line {
			min-width: 22px;
			height: 1px;
			margin: 28px 6px 0;
			background: #bbb;
		}

		.item {
			position: relative;
			margin-top: 4px;
			cursor: pointer;

			&:nth-child(1) {
				margin-left: 15px;
			}
			&:nth-last-child(1) {
				margin-right: 15px;
			}

			.circle {
				border-radius: 50%;
			}
			
			p {
				width: 44px;
				margin-top: 2px;
				font-size: 12px;
				text-align: center;

				^[-1]:hover ^[-1..-1] {
					color: var(--color-main);
				}

				span {
					min-width: 6em;
					text-align: center;
				}
			}

			.tag {
				position: absolute;
				left: 50%;
				top: 0;
				border: 1px solid #fff;
				border-radius: 10px
				padding: 0 5px;
				line-height: 16px;
				font-size: 12px;
				white-space: nowrap;
				color: #fff;
				transform: translate(-50%,-4px);
			}

			.state {
				position: absolute;
				left: 0;
				top: 30px;
				width: 14px;
				height: 14px;
				border-radius: 50%
				font-size: 10px;
				color: #fff;
			}
		}

		&-detail {
			z-index: 1050;
			position: fixed;
			left: 0;
			top: 0;
			width: 360px;
			border-radius: .2px;
			background: #fff;
			box-shadow: 0 0 10px 1px rgba(0,0,0,.15);

			.head {
				height: 52px;
				padding: 0 22px;

				p {
					font-size: 16px;
					font-weight: bold;
				}
			}

			ul {
				padding: 0 22px 14px;
				
				li {
					height: 30px;
					font-size: 13px;
					white-space: nowrap;
					color: #666;

					b {
						color: #000;
					}
				}
			}

			.button {
				a {
					gap: 5px;
					height: 36px;
					border-top: 1px solid #eee;
					font-size: 13px;
					color: #666;

					&:nth-child(n+2) {
						border-left: 1px solid #eee;
					}

					&:hover {
						color: var(--color-main);
					}
				}
			}
		}
	}
</style>
